import React, { useEffect, useRef, forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import agentPageStore from '../store';
import CompositionInput from '@/components/composition-input';
import globalStore from '@/store/global';
import SearchList from './search-list';
import EE from '@/common/event';
import { debounce } from 'lodash-es';

const AgentInput = forwardRef(({ className, scene = 'normal' }, ref) => {

  const {
    isFocus
  } = agentPageStore;
  //const [isFocus, setIsFocus] = useState(true);
  const isTop = scene === 'top';
  const inputRef = useRef(null);
  const inputValueRef = useRef('')
  const config = globalStore.cloudConfig?.assistantAgentHomeConfig || {};

  const onChangeInput = debounce(val => {
    agentPageStore.setInputVal(val)
    inputValueRef.current = val
  }, 500)

  useEffect(() => {
    const handleKeyDown = event => {
      //ESC
      if (event.keyCode == 27) {
        inputRef.current.blur();
      }
    };

    const handleBlur = () => {
      agentPageStore.setIsFocus(false);
      inputRef.current.blur();
    };
    document.addEventListener('keydown', handleKeyDown);
    EE.on('sroll_on_blur', handleBlur)

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      EE.off('sroll_on_blur', handleBlur)
    };
  }, []);

  useEffect(() => {
    if (agentPageStore.showRecordList) {
      agentPageStore.getRecordList();
    }
  }, [agentPageStore.showRecordList]);

  useEffect(() => {
    if (agentPageStore.showSearchList) {
      agentPageStore.getSearchList();
    }
  }, [agentPageStore.showSearchList]);

  return (
    <div
      ref={ref}
      className={[
        'z-200 relative',
        'h-32px mr-10px',
        // isTop
        //   ? 'w-0 h-36px flex-grow max-w-800px mr-16px'
        //   : 'w-800px h-52px mx-auto mb-48px',
        isFocus ? 'w-390px' : 'w-120px',
        // 'w-390px',
        className,
      ]}
      style={{
        transition: 'width 0.3s ease-in-out',
      }}
    >
      <div
        className={[
          'absolute left-0 top-0 w-full min-h-full',
          'border-1px border-black border-opacity-16 overflow-hidden',
          // isTop ? 'rounded-18px' : 'rounded-16px',
          'rounded-18px hover:bg-[rgba(0,0,0,0.03)]',
          isFocus && '!hover:bg-white border-opacity-100',
          'cursor',
        ]}
      >
        <div
          className={[
            'relative',
            'pl-12px pr-12px flex items-center',
            // isTop ? 'w-680px h-36px' : 'w-800px h-52px',
            'h-32px',
            className,
          ]}
        >
          <img 
            src="https://p5.ssl.qhimg.com/t110b9a930197f45a8afdcde225.png"
            className="size-20px mr-4px text-black"
          />
          <CompositionInput
            ref={inputRef}
            className={[
              "h-full !p-0 !text-black text-14px",
              !isFocus ? '!placeholder-black' : '',
              'composition-input-no-border',
            ]}
            bordered={false}
            placeholder={config.placeholder}
            value={agentPageStore.inputVal}
            onFocus={evt => {
              agentPageStore.setIsFocus(true)
              setTimeout(() => {
                if (inputValueRef.current) {
                  agentPageStore.setInputVal(inputValueRef.current)
                }
              }, 100)
            }}
            onBlur={evt => {
              setTimeout(() => {
                agentPageStore.setIsFocus(false)
                agentPageStore.setInputVal('')
              }, 150);
            }}
            onChange={onChangeInput}
          />
          {
            isFocus && agentPageStore.inputVal &&
              <SVGPureIcon
                name="new-agent-close"
                className="size-20px text-black cursor-pointer"
                onClick={() => {
                  agentPageStore.setInputVal("")
                  inputValueRef.current = ''
                }}
              /> 
          }
        </div>
      </div>
      {/* <SearchList inputRef={inputRef} /> */}
      {agentPageStore.showSearchList && <SearchList inputRef={inputRef} />}
      {/* {agentPageStore.showRecordList || agentPageStore.showSearchList ? (
        <SearchList inputRef={inputRef} />
      ) : null} */}
    </div>
  );
});

export default observer(AgentInput);
